import { RatingByBeltType } from '../../store/userSlice'
import {
  StyledCurrentScore,
  StyledPassingMarker,
  StyledProgress,
  StyledProgressContainer,
  StyledProgressWraper,
  StyledTextOverlay
} from './Progress.styled'

type PropsType = {
  data: RatingByBeltType
  beltName: string
  nextBeltName: string
  color?: string
}

const Progress = (props: PropsType) => {
  let colors = ['transparent', 'transparent']

  if (props.color) {
    colors = props.color.split('/').map((item) => {
      return item.trim()
    })

    if (colors.length === 1) {
      colors.push(colors[0])
    }
  }

  return (
    <StyledProgressContainer>
      {props.nextBeltName && (
        <StyledPassingMarker percentage={props.data.passing_percentage}>
          <div>{props.nextBeltName} Belt</div>
        </StyledPassingMarker>
      )}

      <StyledProgressWraper
        primary-color={colors[0]}
        secondary-color={colors.length === 2 ? colors[1] : ''}
        className={'progress-wrapper'}
      >
        <StyledProgress className='progress'>
          <div
            role='progressbar'
            className='progress-bar'
            style={{ width: `${props.data.percentage_complete}%`, border: '1px solid #aaa' }}
          ></div>
          <StyledCurrentScore>
            <div>
              <strong>CURRENT SCORE: {props.data.stars} STARS</strong>
            </div>
          </StyledCurrentScore>
        </StyledProgress>

        <StyledTextOverlay className={'text-overlay'}>
          {props.data.percentage_complete > props.data.passing_percentage ? 'PERFECTION!' : ''}
        </StyledTextOverlay>
      </StyledProgressWraper>
    </StyledProgressContainer>
  )
}

export default Progress
